import * as React from 'react';
import styled from 'styled-components';
import InputNumber, {InputNumberVariant} from 'components/InputNumber';
import {IconRoundPlus} from 'icons';
import {transition} from 'helpers/css';
import {lighten} from 'polished';
import outline from 'helpers/outline';

export interface AddButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  onCreate?(count: number): void;
}

const Container = styled.div`
  position: relative;
  height: 44px;
`;

const Wrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  
  align-items: center;
  justify-content: center;
  display: grid;
`;

const Content = styled.div`
  pointer-events: none;
  gap: 12px;
  align-items: center;
  justify-content: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  text-align: right;
`;

const InputContainer = styled.div`
  pointer-events: auto;
  max-width: 80px;
  border-radius: 6px;
  border: 1px solid ${({theme}) => theme.variables.borderColor};
`;

const Button = styled.button`
  width: 100%;
  height: 100%;
  
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid ${({theme}) => theme.variables.borderColor};
  ${transition()};

  &:hover,
  &:focus {
    background: ${({theme}) => theme.variables.borderColor};
  }
  
  &:focus-visible {
    ${outline(8, 2)};
  }

  &:active {
    background: ${({theme}) => lighten(1, theme.variables.borderColor)};
  }
`;

/**
 * This component render add chapter button with input.
 * @param {AddButtonProps} props
 * @constructor
 */
export default function AddButton(
    props: AddButtonProps,
): React.ReactElement<AddButtonProps> {
  const [
    count,
    setCount,
  ] = React.useState<number>(1);

  /**
   * This is the counter change handler.
   * @param {number} count
   */
  function handleChange(count: number): void {
    setCount(count);
  }

  /**
   * This is creation handler.
   */
  function handleCreate(): void {
    props.onCreate && props.onCreate(count);
  }

  return (
    <Container>
      <Wrapper>
        <Content>
          <IconRoundPlus />
          <Label>
            Добавить день:
          </Label>
          <InputContainer>
            <InputNumber
              minLength={1}
              maxLength={99}
              variant={InputNumberVariant.Accent}
              onChange={handleChange}
            />
          </InputContainer>
        </Content>
      </Wrapper>
      <Button
        {...props}
        onClick={handleCreate}
      />
    </Container>
  );
}
